import { Translatable } from "@icc/shared/helpers";

export class MountingBracket {
    id: number;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    /** Kod do indeksu */
    indexNo?: string;
    /** Kod zewnętrzny */
    extId?: string;
    /** Kod do wydruków */
    printCode?: string;
    /** Krótki opis */
    shortDescription?: string;
    /** Zdjęcie */
    img?: string;
    /** Przypisane typy produktu */
    shutterTypesIds?: number[];
    /** Przypisane profile */
    profilesIds?: number[];
    /** Czy jest to z dystansem */
    withSpacer?: boolean;
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;

    isDefault?: boolean;
}
